export const T = {
  en_GB: {
    authFailed: "Authentication Failed",
    couldntVerify: "We couldn't verify your identity",
    defaultError: "An error occurred during authentication",
    tryAgain: "Please try again or contact support if the problem persists.",
    goBack: "Go Back",
    loading: "Loading...",
    // Unavailable-link reasons (PublicLinkUnavailableReason) — kept word-for-word
    // in sync with `/p/:token/auth` and the member link page.
    linkExpired: "This link has expired. Ask your advisor for a new one.",
    linkRevoked: "This link has been withdrawn by your advisor.",
    representativeRemoved:
      "This link was issued to a representative who is no longer registered for this client. Contact your advisor.",
    representativeChanged:
      "Who signs in for this client has changed, so this link no longer works. Ask your advisor for a new one.",
    memberRemoved:
      "This link was issued to a member who is no longer part of this group. Contact your advisor.",
    linkNotFound: "This link is not valid.",
    eidUnavailable: "BankID sign-in is not available for this link. Contact your advisor.",
  },
  nb_NO: {
    authFailed: "Autentisering mislyktes",
    couldntVerify: "Vi kunne ikke bekrefte identiteten din",
    defaultError: "Det oppstod en feil under autentisering",
    tryAgain: "Vennligst prøv igjen eller kontakt support hvis problemet vedvarer.",
    goBack: "Gå tilbake",
    loading: "Laster...",
    linkExpired: "Denne lenken har utløpt. Be rådgiveren din om en ny.",
    linkRevoked: "Denne lenken er trukket tilbake av rådgiveren din.",
    representativeRemoved:
      "Denne lenken ble utstedt til en representant som ikke lenger er registrert for denne kunden. Kontakt rådgiveren din.",
    representativeChanged:
      "Den som skal logge inn for denne klienten er endret, så denne lenken virker ikke lenger. Be rådgiveren din om en ny.",
    memberRemoved:
      "Denne lenken ble utstedt til et medlem som ikke lenger er en del av denne gruppen. Kontakt rådgiveren din.",
    linkNotFound: "Denne lenken er ikke gyldig.",
    eidUnavailable:
      "BankID-innlogging er ikke tilgjengelig for denne lenken. Kontakt rådgiveren din.",
  },
} as const;
